export default "__VITE_ASSET__36fb7268__"